module.exports = __webpack_public_path__ + "img/icon11.c6c64a7a.png";